import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { getTaskDetails } from 'actions/assignments';
import { setPageTitle } from 'actions/header';
import AttachedUserDocuments from 'components/Presentation/Documents/AttachedUserDocuments';
import { Spinner } from 'UI';

var UserDocuments = /*#__PURE__*/function (_Component) {
  _inherits(UserDocuments, _Component);

  var _super = _createSuper(UserDocuments);

  function UserDocuments(props) {
    var _this;

    _classCallCheck(this, UserDocuments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refreshDocuments", function () {
      var documentRefresh = _this.state.documentRefresh;
      documentRefresh++;

      _this.setState({
        documentRefresh: documentRefresh
      });
    });

    _this.state = {
      documentRefresh: 0,
      assignmentLoading: false,
      activeAssignmentTaskId: null,
      assignmentTasks: null,
      assignmentTask: null,
      assignmentTaskIndexes: null
    };
    _this.goNext = _this.goNext.bind(_assertThisInitialized(_this));
    _this.goPrevious = _this.goPrevious.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UserDocuments, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadAssignment();
    }
  }, {
    key: "loadAssignment",
    value: function loadAssignment() {
      var _this2 = this;

      this.setState({
        assignmentLoading: true
      });
      var that = this;
      this.props.getTaskDetails(this.props.match.params.assignmentId).then(function () {
        _this2.props.setPageTitle(_this2.props.assignment.title);

        that.setState({
          assignmentTasks: that.props.assignment.tasks.sort(function (a, b) {
            return a.groupName.split(' ').pop().localeCompare(b.groupName.split(' ').pop());
          })
        }, function () {
          that.setActiveTaskId(that.props.match.params.taskId);
          that.setTaskIndexes();
          that.setState({
            assignmentLoading: false
          });
        });
      });
    }
  }, {
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "setActiveTaskId",
    value: function setActiveTaskId(taskId) {
      this.setState({
        activeAssignmentTaskId: taskId
      });
      this.setActiveTask(taskId);
    }
  }, {
    key: "setActiveTask",
    value: function setActiveTask(taskId) {
      var assignmentTasks = this.state.assignmentTasks;
      var task = assignmentTasks.filter(function (t) {
        return t.id == taskId;
      })[0];
      this.setState({
        assignmentTask: task
      });
    }
  }, {
    key: "setTaskIndexes",
    value: function setTaskIndexes() {
      var assignmentTasks = this.state.assignmentTasks;
      var taskIndexes = {};
      assignmentTasks.forEach(function (element, index) {
        taskIndexes[element.id] = index;
      });
      this.setState({
        assignmentTaskIndexes: taskIndexes
      });
    }
  }, {
    key: "goNext",
    value: function goNext() {
      var _this$state = this.state,
          assignmentTasks = _this$state.assignmentTasks,
          assignmentTaskIndexes = _this$state.assignmentTaskIndexes,
          activeAssignmentTaskId = _this$state.activeAssignmentTaskId;
      var index = assignmentTaskIndexes[activeAssignmentTaskId];
      index++;

      if (index > assignmentTasks.length - 1) {
        return;
      }

      var output = Object.entries(assignmentTaskIndexes).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          key: key,
          value: value
        };
      });
      var nextActiveAssignmentTaskId = output.filter(function (t) {
        return t.value === index;
      })[0].key;
      this.setActiveTaskId(nextActiveAssignmentTaskId);
      this.refreshDocuments();
    }
  }, {
    key: "goPrevious",
    value: function goPrevious() {
      var _this$state2 = this.state,
          assignmentTaskIndexes = _this$state2.assignmentTaskIndexes,
          activeAssignmentTaskId = _this$state2.activeAssignmentTaskId;
      var index = assignmentTaskIndexes[activeAssignmentTaskId];
      index--;

      if (index < 0) {
        return;
      }

      var output = Object.entries(assignmentTaskIndexes).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        return {
          key: key,
          value: value
        };
      });
      var nextActiveAssignmentTaskId = output.filter(function (t) {
        return t.value === index;
      })[0].key;
      this.setActiveTaskId(nextActiveAssignmentTaskId);
      this.refreshDocuments();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          documentRefresh = _this$state3.documentRefresh,
          assignmentTask = _this$state3.assignmentTask,
          assignmentTasks = _this$state3.assignmentTasks,
          assignmentTaskIndexes = _this$state3.assignmentTaskIndexes,
          activeAssignmentTaskId = _this$state3.activeAssignmentTaskId;

      if (this.state.assignmentLoading || !assignmentTask) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var nextEnable = assignmentTasks.length > 1 && assignmentTaskIndexes[activeAssignmentTaskId] != assignmentTasks.length - 1;
      var previousEnable = assignmentTasks.length > 1 && assignmentTaskIndexes[activeAssignmentTaskId] != 0;
      return /*#__PURE__*/React.createElement("div", {
        id: "documentWidget",
        className: "single-task"
      }, /*#__PURE__*/React.createElement(AttachedUserDocuments, {
        assignmentId: this.props.match.params.assignmentId,
        taskId: activeAssignmentTaskId,
        IsSubmitted: assignmentTask.status === 'ASSIGNMENT_TASK_SUBMITTED',
        documentRefresh: documentRefresh,
        assignmentTask: assignmentTask,
        IsTeacher: true,
        nextEnable: nextEnable,
        previousEnable: previousEnable,
        goNext: this.goNext,
        goPrevious: this.goPrevious
      }));
    }
  }]);

  return UserDocuments;
}(Component);

function mapStateToProps(state) {
  return {
    assignment: state.assignments.active_assignment,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getTaskDetails: getTaskDetails,
  setPageTitle: setPageTitle
})(UserDocuments);